import React from 'react';

export const NoteHeaderElement = (props) => {
  const { children, element } = props;
  const { type } = element;

  if (type === 'note-header-void') {
    return (
      <div
        contentEditable={false}
        className="slate-note-header slate-note-header--void"
      >
        {children}
      </div>
    );
  }

  return (
    <div className="slate-note-header">{children}</div>
  );
};
